import { ResolveFn } from '@angular/router';
import { ensureHolidays } from '../../utils/capacity.utils';

export const timeTrackingHolidaysResolver: ResolveFn<void> = async () => {
  await ensureHolidays();
};
